var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { defaultProps } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
import { inputDateParseDate, parseDate2Str, isEqual, compareDate } from '../DatePicker/utils';
import { formatDate, parseDate } from '@feb-team/data-logic';
import { DateMonthPicker } from './DateMonthPicker';
import { DateDayPicker } from './DateDayPicker';
import { DateHeader } from './DateHeader';
import classnames from 'classnames';
var Calendar = /** @class */ (function (_super) {
    __extends(Calendar, _super);
    function Calendar(props) {
        var _this = _super.call(this, props) || this;
        _this.datePattern = 'yyyy-MM-dd';
        _this.componentWillReceiveProps = function (nextProps) {
            var value = nextProps.value, defaultValue = nextProps.defaultValue;
            var chooseValue = value || defaultValue || null;
            var formatDateValue = inputDateParseDate(chooseValue);
            var parseDateData = _this.getParseDate(formatDateValue, nextProps);
            _this.setState(Object.assign(_this.state, parseDateData));
        };
        /**
         * 格式化数据
         * @param defaultValue
         * @param defaultRangeValues
         */
        _this.getParseDate = function (defaultValue, props) {
            if (props === void 0) { props = _this.props; }
            var disabledItems = props.disabledItems, range = props.range;
            var value = defaultValue ? defaultValue : new Date();
            var values = parseDate(formatDate(value, _this.datePattern));
            var disabledItemsState = [];
            disabledItems.map(function (item) {
                var cacheValue = inputDateParseDate(item);
                if (cacheValue) {
                    disabledItemsState.push(formatDate(cacheValue, _this.datePattern));
                }
            });
            var rangeState = [];
            range.map(function (item) {
                var rangeValue;
                if (item) {
                    var cacheValue = inputDateParseDate(item);
                    if (cacheValue) {
                        rangeValue = formatDate(cacheValue, _this.datePattern);
                    }
                }
                rangeState.push(rangeValue);
            });
            var data = {
                value: formatDate(value, _this.datePattern),
                year: values[0],
                month: values[1],
                day: values[2],
                disabledItems: disabledItemsState,
                range: rangeState,
            };
            return data;
        };
        /**
         * 确认
         */
        _this.confirm = function () {
            var value = _this.state.value;
            value && _this.props.onChoose(value);
        };
        _this.triggerChange = function (date) {
            var value = _this.state.value;
            if (!isEqual(date, value)) {
                _this.props.onChange(date);
            }
        };
        /**
         * 选择日期处理函数
         */
        _this.chooseDay = function (date) {
            var value = _this.state.value;
            var valueDate = new Date(date);
            _this.setState(Object.assign(_this.getParseDate(valueDate)), function () {
                if (!isEqual(date, value)) {
                    _this.confirm();
                }
            });
            _this.triggerChange(date);
        };
        /**
         * 鼠标
         * @param e
         */
        _this.handerMouseDown = function (e) {
            if (_this.state.mouseOver) {
                e.preventDefault();
            }
        };
        /**
         * 鼠标划入
         */
        _this.handleMouseEnter = function () {
            _this.setState({
                mouseOver: true,
            });
        };
        /**
         * 鼠标划出
         */
        _this.handleMouseLeave = function () {
            _this.setState({
                mouseOver: false,
            });
        };
        /**
         * 年份面板更新月
         * @param year
         * @param month
         */
        _this.updateMonth = function (year, month) {
            var _a = _this.state, day = _a.day, range = _a.range;
            var value = parseDate2Str(year, month, day);
            var disabledItems = _this.props.disabledItems;
            var isDisabledItem = disabledItems.includes(value);
            var isDisabled = !((range[0] ? !compareDate(value, range[0]) : true) &&
                (range[1] ? !compareDate(range[1], value) : true));
            //  !传入的不可点击日期  && !区间可点击区域
            var isHasInteraction = !isDisabledItem && !isDisabled;
            if (isHasInteraction) {
                _this.chooseDay(value);
            }
            _this.setState({
                year: year,
                month: month,
                isOpenMonthsPanel: false,
            });
        };
        /**
         * Header 面板 更新年或月
         */
        _this.changeHDate = function (year, month) {
            _this.updateMonth(year, month);
        };
        /**
         * 更新面板类型
         * @param 面板类型
         *
         */
        _this.changeMode = function (mode) {
            _this.setState({
                mode: mode,
            });
            _this.props.onPanelChange(_this.state.value, mode);
        };
        var value = props.value, defaultValue = props.defaultValue;
        var chooseValue = value || defaultValue || null;
        var formatDateValue = inputDateParseDate(chooseValue);
        var parseDateData = _this.getParseDate(formatDateValue);
        _this.state = Object.assign({
            mouseOver: false,
            isOpenYearsPanel: false,
            isOpenMonthsPanel: false,
            nextYear: 0,
            nextMonth: 0,
            nextDay: 0,
            day: 0,
            value: '',
            rangeDate: '',
            mode: props.mode,
        }, parseDateData);
        return _this;
    }
    Calendar.prototype.componentDidMount = function () {
        document.addEventListener('mousedown', this.handerMouseDown);
    };
    Calendar.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handerMouseDown);
    };
    Calendar.prototype.render = function () {
        var _a;
        var _b = this.state, isOpenMonthsPanel = _b.isOpenMonthsPanel, isOpenYearsPanel = _b.isOpenYearsPanel, year = _b.year, month = _b.month, mode = _b.mode, reset = __rest(_b, ["isOpenMonthsPanel", "isOpenYearsPanel", "year", "month", "mode"]);
        var _c = this.props, fullscreen = _c.fullscreen, dateCellRender = _c.dateCellRender, dateFullCellRender = _c.dateFullCellRender, monthCellRender = _c.monthCellRender, monthFullCellRender = _c.monthFullCellRender, defaultValue = _c.defaultValue, value = _c.value, disabledItems = _c.disabledItems, range = _c.range, propsMode = _c.mode, onChoose = _c.onChoose, className = _c.className, headerRender = _c.headerRender, onChange = _c.onChange, rest = __rest(_c, ["fullscreen", "dateCellRender", "dateFullCellRender", "monthCellRender", "monthFullCellRender", "defaultValue", "value", "disabledItems", "range", "mode", "onChoose", "className", "headerRender", "onChange"]);
        return (React.createElement(DivTag, __assign({ name: Calendar.NAME, className: classnames(className, (_a = {},
                _a['datepicker-overflow'] = isOpenYearsPanel || isOpenMonthsPanel,
                _a['calendar-mini'] = !fullscreen,
                _a)), onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave }, rest),
            headerRender ? (headerRender({
                value: value,
                mode: this.state.mode,
                onChange: this.changeHDate,
                onModeChange: this.changeMode,
            })) : (React.createElement(DateHeader, { year: year, month: month, onChange: this.changeHDate, mode: this.state.mode, onModeChange: this.changeMode, fullscreen: fullscreen })),
            this.state.mode === 'year' ? (React.createElement(DateMonthPicker, { year: year, month: month, updateMonth: this.updateMonth, monthCellRender: monthCellRender, monthFullCellRender: monthFullCellRender })) : (React.createElement(DateDayPicker, __assign({ year: year, month: month, dateCellRender: dateCellRender, dateFullCellRender: dateFullCellRender }, reset, { chooseDay: this.chooseDay })))));
    };
    Calendar.defaultProps = defaultProps;
    Calendar.NAME = 'calendar-picker';
    Calendar.displayName = 'Calendar-Picker';
    return Calendar;
}(Component));
export { Calendar };
